import { defineComponent } from 'vue';
import utils from '../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import TranslationContainer from './TranslationContainer.jsx';

export default defineComponent({
    name: 'icon-stack',
    mixins: [BaseComponent],
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        getIconStyles(icon) {
            const styles = {};

            if (this.controlData.FontSize)
                styles['font-size'] = utils.resolveFontSize(this.controlData.FontSize);

            if (icon.Color)
                styles.color = icon.Color;
            else
                styles.color = '#444';

            if (icon.Rotation)
                styles.transform = `rotate(${icon.Rotation}deg)`;

            return styles;
        },
        getIconClass(icon) {
            let iconClass = icon.Icon || '';
            iconClass += icon.FlipHorizontally ? ' mdi mdi-flip-v ' : '';
            iconClass += icon.FlipVertically ? ' mdi mdi-flip-h ' : '';
            iconClass += icon.StackSize === 'Large' ? ' mdi mdi-layers-triple-2x ' : ' mdi mdi-layers ';
            iconClass += icon.Border ? ' mdi mdi-border-all-variant ' : '';
            iconClass += icon.Animation === 'Spin' ? ' mdi-spin ' : '';
            iconClass += icon.Animation === 'Pulse' ? ' c-btn-icon--pulse ' : '';
            return iconClass;
        },
        async onClick(e) {
            e.cancelBubble = true;
            e.stopPropagation();

            await utils.executeAndCompileAllActions(this.controlData.Actions, null, this);
        },
    },
    render() {
        if (!this.todisplay)
            return null;

        const style = {
            ...this.sizeStyle,
            ...utils.resolveStyleHints(this.styleHints, this),
        };

        if (this.controlData.Actions && this.controlData.Actions.length > 0)
            style.cursor = 'pointer';

        const icons = [];
        const iconItems = this.controlData.Icons || [];

        for (let i = 0; i < iconItems.length; i++) {
            const icon = iconItems[i];
            icons.push(
                <i class={this.getIconClass(icon)} style={this.getIconStyles(icon)} aria-hidden="true"></i>
            );
        }

        let caption;
        if (this.controlData.Caption?.Text) {
            caption = (
                <div class="CareIconCaption">
                    <TranslationContainer context={this} value={this.controlData.Caption.Text} />
                </div>
            );
        }

        return (
            <div
                class={{ 'c-IconStack': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                style={style}
                title={!this.controlData.Caption?.Text ? this.controlData.Tooltip : ''}
                onClick={(e) => this.onClick(e)}
            >
                <span class="mdi mdi-layers-triple">
                    {icons}
                </span>
                {caption}
            </div>
        );
    },
});
